import * as React from 'react';
import PropTypes from 'prop-types';
import {Subbar} from "ah-tools";
import {translate} from "react-i18next";
import mapValues from 'lodash/mapValues';
import Segment from "semantic-ui-react/dist/es/elements/Segment/Segment";
import {Button, Form, FormInput, Grid, GridColumn, GridRow, Icon} from "semantic-ui-react";
import {FormLabel, IconButton} from "../extensions";



class DetailedFilters extends React.Component {
	static propTypes = {
		open: PropTypes.bool,
		onChange: PropTypes.func
	};
	
	static DEFAULT_EXTENDED_FILTER = {
		years: {
			from: '',
			till: ''
		},
		ccm: {
			from: '',
			till: ''
		},
		ps: {
			from: '',
			till: ''
		}
	};
	
	state = DetailedFilters.DEFAULT_EXTENDED_FILTER;
	
	hiddenStyle = {
		overflow: 'hidden',
		height: 0,
		visibility: 'none',
		padding: 0,
		margin: 0
	};
	
	updateDetailFilter = (part, range, value = '') => this.setState(state => ({
		...state,
		[part]: {
			...state[part],
			[range]: value
		}
	}));
	
	handled = () =>
		mapValues(this.state, parts =>
			mapValues(parts, value => value === '' ? value : Number(value))
		);
	
	parts = e => e.target.name.split('-');
	
	resetDetailFilter = () => {
		this.setState(DetailedFilters.DEFAULT_EXTENDED_FILTER);
		this.props.onChange && this.props.onChange(DetailedFilters.DEFAULT_EXTENDED_FILTER, true);
		this.forceUpdate();
	};
	
	submit = () => {
		this.props.onChange && this.props.onChange(this.handled(), false);
	};
	
	resetButton = (part, range) => (
		this.state[part][range] !== '' && <IconButton onClick={() => this.updateDetailFilter(part, range)} style={{width: 38, height: 38}}><Icon name={'close'} color={'red'}/></IconButton>
	);
	
	handleEscape = e => {
		if ( e.which !== 27 ) return;
		const [part, range] = this.parts(e);
		this.updateDetailFilter(part, range);
	};
	
	handleChange = (e, input) => {
		const [part, range] = this.parts(e);
		this.updateDetailFilter(part, range, input.value);
	};
	
	render() {
		const {years, ccm, ps} = this.state;
		const {open} = this.props;
		const mainStyle = open ? {} : this.hiddenStyle;
		return (
			<Segment basic inverted style={{...mainStyle}}>
				<Form onSubmit={this.submit}>
					<Grid>
						<GridRow columns={3}>
							<GridColumn>
								<h4>Baujahr</h4>
								<Grid inverted>
									<GridRow columns={2}>
										<GridColumn>
											<FormInput
												labelPosition={'left'}
												fluid type={'number'}
												value={years.from}
												name={'years-from'}
												onChange={this.handleChange}
												onKeyUp={this.handleEscape}
											>
												<FormLabel>von</FormLabel>
												<input/>
												{this.resetButton('years', 'from')}
											</FormInput>
										</GridColumn>
										<GridColumn>
											<FormInput
												labelPosition={'left'}
												fluid type={'number'}
												value={years.till}
												name={'years-till'}
												onChange={this.handleChange}
												onKeyUp={this.handleEscape}
											>
												<FormLabel>bis</FormLabel>
												<input/>
												{this.resetButton('years', 'till')}
											</FormInput>
										</GridColumn>
									</GridRow>
								</Grid>
							</GridColumn>
							<GridColumn>
								<h4>Hubraum</h4>
								<Grid inverted>
									<GridRow columns={2}>
										<GridColumn>
											<FormInput
												labelPosition={'left'}
												fluid
												type={'number'}
												value={ccm.from}
												name={'ccm-from'}
												onChange={this.handleChange}
												onKeyUp={this.handleEscape}
											>
												<FormLabel>von</FormLabel>
												<input/>
												{this.resetButton('ccm', 'from')}
											</FormInput>
										</GridColumn>
										<GridColumn>
											<FormInput
												labelPosition={'left'}
												fluid
												name={'ccm-till'}
												type={'number'}
												value={ccm.till}
												onChange={this.handleChange}
												onKeyUp={this.handleEscape}
											>
												<FormLabel>bis</FormLabel>
												<input/>
												{this.resetButton('ccm', 'till')}
											</FormInput>
										</GridColumn>
									</GridRow>
								</Grid>
							</GridColumn>
							<GridColumn>
								<h4>PS</h4>
								<Grid inverted>
									<GridRow columns={2}>
										<GridColumn>
											<FormInput
												labelPosition={'left'}
												fluid
												type={'number'}
												name={'ps-from'}
												value={ps.from}
												onChange={this.handleChange}
												onKeyUp={this.handleEscape}
											>
												<FormLabel>von</FormLabel>
												<input/>
												{this.resetButton('ps', 'from')}
											</FormInput>
										</GridColumn>
										<GridColumn>
											<FormInput
												labelPosition={'left'}
												fluid
												type={'number'}
												name={'ps-till'}
												value={ps.till}
												onChange={this.handleChange}
												onKeyUp={this.handleEscape}
											>
												<FormLabel>bis</FormLabel>
												<input/>
												{this.resetButton('ps', 'till')}
											</FormInput>
										</GridColumn>
									</GridRow>
								</Grid>
							</GridColumn>
						</GridRow>
						<GridRow columns={1}>
							<GridColumn>
								<Subbar align={Subbar.ALIGN_BETWEEN}>
									<Button type={'button'} negative icon onClick={this.resetDetailFilter}><Icon name={'close'}/> zurücksetzen</Button>
									<Button type={'submit'} positive icon><Icon name={'filter'}/> Filter setzen</Button>
								</Subbar>
							</GridColumn>
						</GridRow>
					</Grid>
				</Form>
			</Segment>
		);
	}
}

export default translate()(DetailedFilters);


// WEBPACK FOOTER //
// ./src/misc/DetailedFilters.js